angular.module('impactx.product').controller('ProductSelectionListCtrl', [
    '$scope',
    'panelService',
    'SearchService',
    'searchFilter',
    'DialogPanelService',
    '$routeParams',
    'TranslationService',
    'dataGen',
    ProductSelectionListCtrl]);

function ProductSelectionListCtrl($scope, panelService, SearchService, searchFilter, DialogPanelService, $routeParams, TranslationService, dataGen) {
    var self = this;

    if(!$scope.trns){
        $scope.trns = {};
    }
    $scope.selectLabel = TranslationService.get('select');
    $scope.selectedLabel = TranslationService.get('selected');
    
    self.searchInput = "";
    self.getProductPanelColor = panelService.getProductPanelColor;
    self.locals = DialogPanelService.readLocals();
    self.selectedRows = [];
    self.showDefaultActions = !self.locals.hideDefaultAction;
    self.useMultiSelect = !!self.locals.useMultiSelect;
    self.showFilters = !self.locals.hideFilters;
    
    self.itemActions = impactX.isDefined(self, 'locals.itemActions') || [];
    self.listActions = impactX.isDefined(self, 'locals.listActions') || [];

    self.selectedVCat = impactX.isDefined(self, 'locals.vcat');
    self.forProductView = impactX.isDefined(self, 'locals.forProductView');
    self.checkOutCatId = impactX.isDefined(self, 'locals.checkOutCatId');

    self.alternateContextUserId = impactX.isDefined(self, 'locals.ctxUsrId') || 0;
    self.rfqhId = impactX.isDefined(self, 'locals.rfqhId') || 0;

    self.useVCATFilter = !!self.locals.usevcatfilter;
    if(self.useVCATFilter)
    {
        // this isn't the best fallback but currently the one that makes the most sense
        self.vcatFilterEntryPoint = self.locals.vcatFilterEntryPoint || "/compilationarticle/catalog/input";

        $scope.$watch(function () {
            return impactX.isDefined(self, 'selectedVCat.id');
        }, function (newValue, oldValue) {
            if (!angular.equals(newValue, oldValue)) {
                self.search();
            }
        });
    }

    searchFilter.reset();

    self.selectProduct = function (event, product, index) {
        DialogPanelService.setTransferData(product);
        SearchService.consumableTopIndexOtherProductSearch.value = index;
        DialogPanelService.closePanel();
        event.stopPropagation();
        event.preventDefault();
    };

    self.applySelection = function () {
        DialogPanelService.setTransferData(self.selectedRows);
        DialogPanelService.closePanel();
    };
    
    self.toggleProductSelection = function (product) {
        if (product.selected)
        {
            self.selectedRows.push(product);
        }
        else
        {
            var index = self.selectedRows.indexOf(product);
            if (index >= 0)
            {
                self.selectedRows.splice(index, 1);
            }
        }
        event.stopPropagation();
    };

    self.deselectAllRows = function () {
        angular.forEach(self.selectedRows, function (row) {
            row.selected = false;
        });
        self.selectedRows.length = 0;
    };

    self.updateFilterData = function () {
        $scope.products = SearchService.model.data.searchResults.products;
        for (var key in SearchService.model.trns) {
            if (SearchService.model.trns.hasOwnProperty(key)) {
                $scope.trns[key] = SearchService.model.trns[key];
            }
        }
        $scope.no_result = SearchService.model.no_result;
        $scope.filters = [];
        $scope.filters.push(searchFilter.getSearchFilterData().tenderId);
        $scope.filters.push(searchFilter.getSearchFilterData().lotId);
        if (!self.useVCATFilter) // only add it if not a changeable filter
        {
            $scope.filters.push(searchFilter.getSearchFilterData().vcatalogId);
        }
        $scope.filters.push(searchFilter.getSearchFilterData().supplierId);
        $scope.fixedFilters = searchFilter.getSearchFilterData();
        $scope.searchFilter = searchFilter;
        var attributeSearch = SearchService.model.data.searchResults.attributeSearch;
        $scope.numberOfProducts = SearchService.model.data.searchResults.numOfProducts;
        if (attributeSearch) {
            $scope.facetResults = attributeSearch.facetResults;
            $scope.guidedFacetResult = attributeSearch.guidedFacetResult;
        }
        else {
            $scope.facetResults = [];
        }
    };

    self.toggleAll = function () {
        if ($scope.numberOfAttributes < 0) {
            $scope.numberOfAttributes = 3;
        }
        else {
            $scope.numberOfAttributes = -1;
        }
    };

    self.search = function () {
        // only search if 2 or more characters
        if (!self.searchInput || self.searchInput.length > 1) {
            var preLoadingNumber = 20;
            var lastTopIndex = SearchService.consumableTopIndexOtherProductSearch.value;
            var stepSize = 10;
            searchFilter.hideSearchInput = true;
            searchFilter.clearSearchInput();
            searchFilter.otherSearchInput = self.searchInput;
            $routeParams.supplierId = impactX.isDefined(self, 'locals.supplier.id');
            $routeParams.vcatId = impactX.isDefined(self, 'selectedVCat.id');
            var mycscid = impactX.isDefined(self, 'locals.cscId');

            SearchService.consumableTopIndexOtherProductSearch.value = 0;
            SearchService.handleInfiniteProductSearch($scope, lastTopIndex, stepSize, preLoadingNumber, self.forProductView,
                self.updateFilterData, mycscid, self.checkOutCatId, self.alternateContextUserId, self.rfqhId);
        }
    };

    self.search();

    self.showProductDetails = function (product) {
        if ($scope.lastClickedProId == product.id) {
            $scope.lastClickedProId = undefined;
        }
        else {
            receiveProductInfo(product).then(function () {
                $scope.lastClickedProId = product.id;
            });
        }
    };

    self.checkActionCondition = function(action) {
        if (action.hasOwnProperty('condition')) {
            if (typeof action.condition === 'function') {
                return action.condition();
            }
            else {
                return action.condition;
            }
        }
        // no condition defined => always show
        return true;
    };
    
    self.performListAction = function(action) {
        action.action().then(function(){
            if(action.closeAfter) {
                DialogPanelService.closePanel();
            } else if(action.reloadAfter) {
                self.search();
            }
        });
    };
    
    self.performItemAction = function(action, product, index) {
        event.stopPropagation();
        action.action(product, index).then(function() {
            if (action.closeAfter) {
                DialogPanelService.closePanel();
            } else if (action.reloadAfter) {
                self.search();
            }
        });
    };

    $scope.$on('$destroy', function () {
        searchFilter.reset();
        searchFilter.otherSearchInput = undefined;
    });

    function receiveProductInfo(product) {
        var result = {};
        return dataGen.getData(result, {proId: product.id}, "/product/info", null, false).then(function () {
            var productInfo = impactX.isDefined(result, 'data');
            if (productInfo) {
                for (var property in productInfo) {
                    if (productInfo.hasOwnProperty(property)) {
                        product[property] = productInfo[property];
                    }
                }
            }
        });
    }
    
    $scope.showSearch = {value: true};
    
    self.toggleSearch = function () {
        $scope.showSearch.value = !$scope.showSearch.value;
    };

    var checkFilter = function(filter) {
        return !!(filter && (filter.value || filter.selected))
    };


    self.anyFiltersSet = function() {
        var filterdata = $scope.fixedFilters;
        if(filterdata) {
            if (filterdata.drillDowns && filterdata.drillDowns.length > 0) {
                return true;
            }
            return !!self.searchInput
                || checkFilter(filterdata.supplier)
                || checkFilter(filterdata.manufacturer)
                || checkFilter(filterdata.contractNo)
                || checkFilter(filterdata.supplierNo)
                || checkFilter(filterdata.category)
                || checkFilter(filterdata.sort)
                || checkFilter(filterdata.priceRange.minValue)
                || checkFilter(filterdata.priceRange.maxValue);
        }
        return false;
    };
    
    self.clearSearchInput = function() {
        self.searchInput = undefined;
    }
}